export default "assets/images/icons/mute-6f2dda19.svg";